import React from "react";
import { useAuth } from "../context/AuthContext";
import { Clock, Users } from "lucide-react";
import { Briefcase, Shield } from "lucide-react";

const Dashboard = () => {
  const user = useAuth().user;
  console.log("user role in dashboard comp:", user);
  const projects = []; // Replace with actual project data fetching logic

  const stats = [
    {
      title: "Total Projects",
      value: projects?.length || 0,
      icon: Briefcase,
      color: "text-blue-500",
      bg: "bg-blue-500/10",
    },
    {
      title: "Total Users",
      value: "Active",
      icon: Users,
      color: "text-green-500",
      bg: "bg-green-500/10",
    },
    {
      title: "Your Role",
      value: user?.role?.toUpperCase(),
      icon: Shield,
      color: "text-purple-500",
      bg: "bg-purple-500/10",
    },
  ];
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 animate-fade-in ">
        {stats.map((stat, i) => (
          <div
            key={i}
            className="w-[300px] h-[150px] mx-auto rounded-xl border bg-white border-gray-300 text-card-foreground shadow-lg p-5"
          >
            <div className="flex flex-row items-center justify-between pb-2 space-y-0">
              <div className="text-sm font-medium text-gray-500">
                {stat.title}
              </div>
              <div className={`p-2 rounded-md ${stat.bg}`}>
                <stat.icon className={`h-4 w-4 ${stat.color}`} />
              </div>
            </div>
            <div>
              <div className="text-2xl font-bold">{stat.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="w-full space-y-4 h-auto rounded-xl border bg-white border-gray-300 text-card-foreground shadow-lg p-5 animate-fade-in ">
        <div className="text-lg flex items-center gap-2">
          <Clock className="h-5 w-5 text-muted-foreground" />
          Recent Activities
        </div>
        <div className="flex items-center justify-between p-3  border rounded-lg hover:bg-gray-100 transition-colors">
          <div className="flex flex-col">
            <span className="font-medium">Q1 Marketing Campaign</span>
            <span className="text-xs text-muted-foreground">
              Main campaign for brand awareness
            </span>
          </div>
          <span className="text-xs text-muted-foreground">Jan 23, 19:26</span>
        </div>

        <div className="text-center py-8 text-muted-foreground">
          No recent activity found.
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
